import { Lock } from 'lucide-react'
import { api } from '../api'
import { BrandLogo } from '../components/Theme'
import { useMe } from '../session'

// Signed in, but nobody has granted hub.access yet. Showing the person's own
// Hub ID lets an administrator find them without guessing by email.
export function NoAccessPage() {
  const me = useMe()
  async function signOut() {
    const { redirectTo } = await api.signOut()
    window.location.assign(redirectTo)
  }
  return (
    <main className="center-page">
      <div className="card center-card">
        <div className="card-body stack" style={{ alignItems: 'center' }}>
          <BrandLogo size="page" />
          <p className="eyebrow">
            <Lock size={13} aria-hidden /> BRE Hub
          </p>
          <h1 className="center-title">You're signed in, {me.displayName.split(/\s+/)[0]}</h1>
          <p className="muted" style={{ margin: 0 }}>
            Your account doesn't have Hub access yet. Ask a Hub administrator to grant it.
          </p>
          <p className="faint" style={{ margin: 0 }}>
            Your Hub ID: <span className="mono">{me.personId}</span>
          </p>
          <button type="button" className="btn" onClick={signOut}>
            Sign out
          </button>
        </div>
      </div>
    </main>
  )
}
